import React from 'react';

import { Button, createStyles } from '@mantine/core';

const pulseGlowKeyFrames = `
  @keyframes pulse-glow-once {
    0%   { transform:translateX(-50%) scale(1);   box-shadow:0 0 0 0 var(--glow-color); }
    50%  { transform:translateX(-50%) scale(1.06);box-shadow:0 0 0 12px transparent; }
    100% { transform:translateX(-50%) scale(1);   box-shadow:0 0 0 0 transparent; }
  }
`;

const useStyles = createStyles(() => ({
  viewWorkoutButton: {
    position: 'fixed',
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: 'max(env(safe-area-inset-bottom, 85px), 85px)',
    width: 'clamp(280px, 90vw, 340px)',
    zIndex: 10,
    '--glow-color': 'rgba(255, 28, 28, 0.7)',
    animation: 'pulse-glow-once 1.5s ease-out',

    // Override the native mantine active style to keep the translateX
    '&:active': {
      transform: 'translateX(-50%) translateY(0.0625rem)',
    },
  },
}));

export const ViewWorkoutButton: React.FC = () => {
  const { classes } = useStyles();

  return (
    <>
      <style>{pulseGlowKeyFrames}</style>
      <Button
        href='https://www.wodup.com/login'
        component='a'
        color='red'
        radius='xl'
        size='md'
        leftIcon={
          <svg width={20} height={21} viewBox='0 0 20 21' fill='none'>
            <g clipPath='url(#clip0_267_564)'>
              <path
                d='M9.69712 5.52658L5.83843 8V14.2309C5.83843 15.5872 6.06183 17.0852 7.7881 17.0852C9.59562 17.0852 9.69712 15.6479 9.69712 14.2309V5.52658ZM2 8H5.83451V4.17818L11.5 0.5L17.3382 4.17818V8.00026L13.5356 5.56508V14.2309C13.5356 16.0123 13.3325 17.5306 12.0327 18.8261C10.8954 19.9799 9.43314 20.4455 7.82869 20.4455C6.2649 20.4455 4.59954 20.0002 3.50288 18.8463C2.14216 17.4091 2 16.1338 2 14.2309V8Z'
                fill='#fff'
              />
            </g>
            <defs>
              <clipPath id='clip0_267_564'>
                <rect width={20} height={20} fill='#fff' transform='translate(0 0.5)' />
              </clipPath>
            </defs>
          </svg>
        }
        className={classes.viewWorkoutButton}
      >
        View workout
      </Button>
    </>
  );
};
